// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"b8d04b6c","707":"3424a9dc","729":"c5f5fd73"}[chunkId] + ".js";
};